import { ISignatureProps, getSignatureHtml } from "../helpers";

const Preview: React.FC<ISignatureProps> = (props) => {
    return (
        <div dangerouslySetInnerHTML={{__html: getSignatureHtml(props)}}></div>
    );
}

export default Preview;